import {
  EServiceType,
  ICheckPublishTermSchema,
} from '../../../../repositories/billing-tariffs/entities/PublishTerms/CheckPublishTermSchema';
import { IServicePeriod } from '../../../../types/reducers/publishTerms';

interface IMapCalltrackingTermParams {
  period: IServicePeriod;
}

export function mapCalltrackingTerm(params: IMapCalltrackingTermParams): ICheckPublishTermSchema {
  const { period } = params;
  const { type, days, tariffIdentificator } = period;

  return {
    type,
    days,
    services: [EServiceType.calltracking],
    tariffIdentificator,
  };
}
